import { cn } from '@sohanemon/utils';
import { ClientOnly } from '@tanstack/react-router';
import type { ComponentProps } from 'react';
import Writer from 'typewriter-effect';
import { useSohanEmon } from '#/lib/hooks/sohanemon.tsx';

type TypeWriterProps = ComponentProps<typeof Writer> & { className?: string };

export function TypeWriter({ className, ...props }: TypeWriterProps) {
	return (
		<ClientOnly
			fallback={
				<h3
					className={cn(
						'inline-block px-10 text-center font-typewriter text-primary lg:pt-4 lg:text-xl',
						className,
					)}
					{...props}
				>
					<div className="h-8 w-32 animate-pulse rounded-md bg-primary/10" />
				</h3>
			}
		>
			<TypeWriterClient className={className} {...props} />
		</ClientOnly>
	);
}

function TypeWriterClient({ className, ...props }: TypeWriterProps) {
	const { typewriter: strings } = useSohanEmon();

	return (
		<Writer
			options={{
				strings,
				wrapperClassName: cn(className),
				deleteSpeed: 0.4,
				cursor: '▋',
				autoStart: true,
				loop: true,
			}}
			{...props}
		/>
	);
}
